import { NoDecimalFormatterDirective } from './directives/no-decimal-formatter.directive';
import { CommonModule, registerLocaleData } from "@angular/common";
import { NgModule, LOCALE_ID } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MAT_DATE_FORMATS, DateAdapter } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { AcceptCookieComponent } from "@app/custom-shared/components/alerts/accept-cookie/accept-cookie.component";
import { CookieDetailsDialogComponent } from "@app/custom-shared/components/alerts/cookie-details-dialog/cookie-details-dialog.component";
import { ConfirmBoxComponent } from "@app/custom-shared/components/alerts/confirm-box/confirm-box.component";
import { DialogBoxService } from "@app/custom-shared/components/alerts/dialog-box-service";
import { PromptBoxComponent } from "@app/custom-shared/components/alerts/prompt-box/prompt-box.component";
import { SnackbarComponent } from "@app/custom-shared/components/alerts/snackbar/snackbar.component";
import { AppAutoCompleteComponent } from "@app/custom-shared/components/form/app-auto-complete/app-auto-complete.component";
import { AppCalendarDateAdapter } from "@app/custom-shared/components/form/app-calendar/app-calendar-header/app-calendar-date-adapter";
import { AppCalendarHeaderComponent, PTBR_DATE_FORMAT } from "@app/custom-shared/components/form/app-calendar/app-calendar-header/app-calendar-header.component";
import { AppCalendarComponent } from "@app/custom-shared/components/form/app-calendar/app-calendar.component";
import { AppDropdownComponent } from "@app/custom-shared/components/form/app-dropdown/app-dropdown.component";
import { LabelErrorComponent } from "@app/custom-shared/components/form/label-error/label-error.component";
import { CaceisIconComponent } from "@app/custom-shared/components/icons/caceis-icon/caceis-icon.component";
import { ClickStopPropagation } from "@app/custom-shared/directives/event/click-stop-propagation.directive";
import { CaceisInputTextDirective } from "@app/custom-shared/directives/form/inputs/caceis-input-text/caceis-input-text.directive";
import { PdfGeneratorDirective } from "@app/custom-shared/directives/pdf/pdf-generator.directive";
import { IfMasterBoDirective } from "@app/custom-shared/directives/profile/if-master-bo.directive";
import { IfMasterClientBoDirective } from "@app/custom-shared/directives/profile/if-master-client-bo.directive";
import { IfMasterClientDirective } from "@app/custom-shared/directives/profile/if-master-client.directive";
import { PermissionsManagerService } from "@app/custom-shared/services/permissions-manager.service";
import { ProfileManagerService } from "@app/custom-shared/services/profile-manager.service";
import { DropdownModule } from "primeng/dropdown";
import { DialogModule } from "primeng/dialog";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { ErrorScreenComponent } from "./components/error-screen/error-screen.component";
import { MultiDatepickerModule } from "./components/multidatepicker/multidatepicker.module";
import { MyDisableIfUnauthorizedDirective } from "./directives/disable-if-unauthorized.directive";
import { MyHideIfUnauthorizedDirective } from "./directives/hide-if-unauthorized.directive";
import { ShowIfTruncatedDirective, TooltipArrayToString, SortByPipe } from "./directives/show-if-truncated.directive";
import { ToolTipDirective } from "./directives/tooltip.directive";
import { CellFormat } from "./pipes/cellPhone.pipe";
import { CpfFormat } from "./pipes/cpf.pipe";
import { RgFormat } from "./pipes/rg.pipe";
import localePt from '@angular/common/locales/pt';
import { ServiceInjectorModule } from "@app/service-injector.module";
import { SpinnerCardComponent } from "@app/custom-shared/components/loaders/spinner-card/spinner-card.component";
import { CustomMenuComponent } from "@app/custom-shared/custom-menu/custom-menu.component";
import { NoDecimalPipe } from './pipes/no-decimal.pipe';
import { GroupedButtonModule } from './components/grouped-button/grouped-button.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { CustomDashboardsComponent } from '@app/custom-shared/custom-dashboards/custom-dashboards.component';

registerLocaleData(localePt, 'pt-BR');

/**
 *  Custom shared module used to declare custom pipes, directives, utilities ....
 *  This file will not be deleted or overwritten by Palmyra Generator
 */
@NgModule({
  imports: [
    InputNumberModule,
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    DialogModule,
    CommonModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MultiDatepickerModule,
    MatAutocompleteModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    DropdownModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    ServiceInjectorModule,
    GroupedButtonModule
  ],
  declarations: [
    CustomDashboardsComponent,
    CustomMenuComponent,
    LabelErrorComponent,
    ConfirmBoxComponent,
    SnackbarComponent,
    CaceisIconComponent,
    ToolTipDirective,
    ShowIfTruncatedDirective,
    TooltipArrayToString,
    SortByPipe,
    MyHideIfUnauthorizedDirective,
    MyDisableIfUnauthorizedDirective,
    PromptBoxComponent,
    CaceisInputTextDirective,
    CpfFormat,
    RgFormat,
    CellFormat,
    PromptBoxComponent,
    ConfirmBoxComponent,
    SnackbarComponent,
    IfMasterClientDirective,
    IfMasterBoDirective,
    IfMasterClientBoDirective,
    AcceptCookieComponent,
    CookieDetailsDialogComponent,
    ClickStopPropagation,
    ErrorScreenComponent,
    AppDropdownComponent,
    AppAutoCompleteComponent,
    AppCalendarComponent,
    AppCalendarHeaderComponent,
    CheckboxComponent,
    PdfGeneratorDirective,
    SpinnerCardComponent,
    NoDecimalPipe,
    NoDecimalFormatterDirective
    ],
  exports: [
    CustomDashboardsComponent,
    InputNumberModule,
    CustomMenuComponent,
    LabelErrorComponent,
    MatSnackBarModule,
    MatDialogModule,
    CaceisIconComponent,
    ToolTipDirective,
    ShowIfTruncatedDirective,
    TooltipArrayToString,
    SortByPipe,
    MyHideIfUnauthorizedDirective,
    MyDisableIfUnauthorizedDirective,
    CpfFormat,
    RgFormat,
    CellFormat,
    PromptBoxComponent,
    ConfirmBoxComponent,
    SnackbarComponent,
    CaceisInputTextDirective,
    IfMasterClientDirective,
    IfMasterBoDirective,
    IfMasterClientBoDirective,
    MultiDatepickerModule,
    AcceptCookieComponent,
    CookieDetailsDialogComponent,
    ClickStopPropagation,
    AppDropdownComponent,
    AppAutoCompleteComponent,
    AppCalendarComponent,
    AppCalendarHeaderComponent,
    ReactiveFormsModule,
    CheckboxComponent,
    PdfGeneratorDirective,
    SpinnerCardComponent,
    ServiceInjectorModule,
    NoDecimalFormatterDirective,
    NoDecimalPipe,
    GroupedButtonModule,
    MatSortModule,
    MatTableModule,
    MatCardModule,
    MatCheckboxModule 
  ],
  entryComponents: [ConfirmBoxComponent, SnackbarComponent, PromptBoxComponent, AcceptCookieComponent, CookieDetailsDialogComponent, AppCalendarComponent, AppCalendarHeaderComponent, CheckboxComponent,],
  providers: [
    DialogBoxService,
    PermissionsManagerService,
    ProfileManagerService,
    NoDecimalPipe,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MAT_DATE_FORMATS, useValue: PTBR_DATE_FORMAT },
    //{ provide: DateAdapter, useClass: AppCalendarDateAdapter },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
  ],
})
export class CustomSharedModule { }
